import React from 'react';
import {  CustomLabel, SapphireBlueButton, FlexContainer, BenefitModalWrapper } from '../styles';
import ModalComponent from './Modal';

type Props = {
  onClose: () => void;
  body: string | React.ReactNode;
  title: string;
  onSubmit?: () => void;
  submitButtonTitle?: string;
  showFooter?: boolean;
  footerContent?: React.ReactNode;
};

const ConfirmationModal: React.FC<Props> = ({
  onClose,
  body,
  title,
  onSubmit,
  submitButtonTitle,
  footerContent,
  showFooter = true,
}) => {
  return (
    <BenefitModalWrapper>
      <ModalComponent
        title={title}
        titleFontSize="22px"
        bodyPadding="20px 20px"
        onClose={() => onClose && onClose()}
        showFooter={showFooter}
        wrapperWidth="500px"
        bodyBackgroundColor="#F4F7FB"
        footerHeight="auto"
        footerContent={
          footerContent || (
            <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
              <SapphireBlueButton minWidth="120px" height="40px" onClick={() => onClose && onClose()}>
                Cancel
              </SapphireBlueButton>
              <SapphireBlueButton primary minWidth="120px" height="40px" onClick={() => onSubmit?.()}>
                {submitButtonTitle || 'Confirm'}
              </SapphireBlueButton>
            </FlexContainer>
          )
        }
      >
        <CustomLabel textAlign="center" lineHeight="30px">
          {body}
        </CustomLabel>
      </ModalComponent>
    </BenefitModalWrapper>
  );
};

export default ConfirmationModal;
